



















import Vue from 'vue'
import { mdiTruckDelivery, mdiInformation } from '@mdi/js'
import { BaseCardTitle, BaseDataItem } from '@/components'
import { ShippingUpdater } from './components'
import { IShipping } from '@/models'
import { SHIPPING_STATE } from '@/enums'

export default Vue.extend({
    name: 'PaymentStatus',

    components: { BaseCardTitle, BaseDataItem, ShippingUpdater },

    model: {
        prop: 'shipping',
        event: 'update:shipping',
    },

    props: {
        orderCode: {
            type: String,
            required: true,
        },
        shipping: {
            type: Object as () => IShipping,
            required: true,
        },
    },

    data: () => ({ mdiTruckDelivery, mdiInformation }),

    computed: {
        shippingInternal: {
            get(): IShipping {
                return this.shipping
            },
            set(shipping: IShipping) {
                this.$emit('update:shipping', shipping)
            },
        },

        shippingStateName(): string {
            switch (this.shipping.state) {
                case SHIPPING_STATE.WAITING_PAYMENT:
                    return 'Oczekuje płatności'
                case SHIPPING_STATE.WAITING_ACCEPT:
                    return 'Oczekuje na realizację'
                case SHIPPING_STATE.TO_DELIVERY:
                    return 'W trakcie przygotowania do wysyłki'
                case SHIPPING_STATE.BEEING_DELIVERED:
                    return 'W drodze'
                case SHIPPING_STATE.DELIVERED:
                    return 'Dostarczona'
                case SHIPPING_STATE.CANCELLED:
                    return 'Anulowana'
                default:
                    throw new Error(`Unknown shipping state: ${this.shipping.state}`)
            }
        },

        isShippingInProgress(): boolean {
            return [
                SHIPPING_STATE.WAITING_ACCEPT,
                SHIPPING_STATE.TO_DELIVERY,
                SHIPPING_STATE.BEEING_DELIVERED,
            ].includes(this.shipping.state)
        },
    },
})
